__turbopack_context__.v({
  "Cont": "Content-module-sass-module__3SNbwW__Cont",
  "Content": "Content-module-sass-module__3SNbwW__Content",
  "Inner": "Content-module-sass-module__3SNbwW__Inner",
  "Title": "Content-module-sass-module__3SNbwW__Title",
});
